var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgUpload(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 49,
    viewBox: "0 0 56 49",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.2917 48.3261C11.8199 48.0596 8.52109 46.7029 5.86631 44.4497C3.21153 42.1966 1.33651 39.1623 0.508986 35.7801C-0.318537 32.3978 -0.0562514 28.8406 1.25839 25.6163C2.57304 22.392 4.87282 19.6655 7.82935 17.8261C8.45844 12.9209 10.8534 8.41308 14.5661 5.14616C18.2787 1.87923 23.0546 0.0771484 28 0.0771484C32.9454 0.0771484 37.7213 1.87923 41.4339 5.14616C45.1466 8.41308 47.5416 12.9209 48.1707 17.8261C51.1272 19.6655 53.427 22.392 54.7416 25.6163C56.0563 28.8406 56.3186 32.3978 55.491 35.7801C54.6635 39.1623 52.7885 42.1966 50.1337 44.4497C47.4789 46.7029 44.1801 48.0596 40.7083 48.3261V48.3744H15.2917V48.3261ZM30.5417 28.0411H38.1667L28 15.3328L17.8333 28.0411H25.4583V38.2078H30.5417V28.0411Z",
    fill: "#1E2C4F",
    fillOpacity: 0.64
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgUpload);
export default __webpack_public_path__ + "static/media/upload.b37aac97d5a5b53136168b5cda7e58b7.svg";
export { ForwardRef as ReactComponent };